const initialState = {
  error: {},
  loading: false,
  paymentDetail: {},
  payments: [],
  totalPayments: 0,
  recentPayments: [],
  formSubmitted: false
};

const PAYMENT_REDUCER = (state = initialState, { type, payload }) => {
  switch (type) {
    case "PAYMENT_LOADING": {
      return {
        ...state,
        formSubmitted: false,
        loading: true,
      };
    }
    case "PAYMENT_COMPLETE": {
      return {
        ...state,
        loading: false,
      };
    }
    case "PAYMENT_SUBMITTED": {
      return {
        ...state,
        loading: false,
        formSubmitted: true
      };
    }
    case "VIEW_PAYMENT": {
      return {
        ...state,
        paymentDetail: {
          pdfData: payload.data,
          fileName: payload.fileName,
        },
      };
    }
    case "CLEAR_PAYMENTDETAILS": {
      return {
        ...state,
        paymentDetail: {},
      };
    }
    case "PAYMENT_ERROR": {
      return {
        ...state,
        error: payload,
        loading: false,
      };
    }
    case "ALL_PAYMENT": {
      // @deprecated — old MongoDB server shape: payload was a flat array with totalCount on each item
      // New shape from payment service: { data: [...], total, page, pageSize, totalPages }
      return {
        ...state,
        payments: payload.data || [],
        totalPayments: payload.total || 0,
        loading: false,
      };
    }
    case "RECENT_PAYMENTS": {
      return {
        ...state,
        recentPayments: payload || [],
      };
    }
    default:
      return state;
  }
};

export default PAYMENT_REDUCER;
